import { Paper, useTheme } from "@mui/material";
import React from "react";

function BackgroundPage({ children }) {
  const backgroundPage = useTheme()?.backgroundPage;
  return (
    <Paper
      elevation={0}
      sx={{ minHeight: "100vh", background: backgroundPage }}
    >
      {children}
    </Paper>
  );
}

export default BackgroundPage;
